export default function MySQL_TRIM() {
  return (
    <div>
      <h2>MySQL_TRIM</h2>    </div>
  );
}